import { render } from "./IVRBlacklistView.vue?vue&type=template&id=0817027f&scoped=true"
import script from "./IVRBlacklistView.vue?vue&type=script&lang=js"
export * from "./IVRBlacklistView.vue?vue&type=script&lang=js"

import "./IVRBlacklistView.vue?vue&type=style&index=0&id=0817027f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0817027f"]])

export default __exports__